const courseStatus = [
  {
    id: 'CREATED',
    name: 'CREATED',
  },
  {
    id: 'ACTIVE',
    name: 'ACTIVE',
  },
];

export default courseStatus;
